module.exports = __webpack_public_path__ + "static/erinis_gloom_stalker-1c979c0da2ddf77a6ebe799984f54e7a.jpg";